export const REFRESH_SAMPLE_LIST_NEW = 'REFRESH_SAMPLE_LIST_NEW';

export const refreshSampleListNew = samplesData => ({
  type: REFRESH_SAMPLE_LIST_NEW,
  samplesData
});



// WEBPACK FOOTER //
// ./src/actions/sampleListNew.js